import { css } from 'linaria';

export const gallery__container = css`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(283px, 1fr));
  gap: var(--space-200);

  @media (max-width: 1200px) {
    & > div {
      &:last-child,
      &:nth-last-child(2) {
        display: none;
      }
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));

    & > div {
      &:last-child,
      &:nth-last-child(2),
      &:nth-last-child(3),
      &:nth-last-child(4) {
        display: none;
      }
    }
  }

  @media (max-width: 550px) {
    grid-template-columns: repeat(auto-fit, minmax(171px, 1fr));
  }

  @media (max-width: 450px) {
    grid-template-columns: repeat(auto-fit, minmax(136px, 1fr));

    & > div {
      height: 250px !important;
    }
  }

  @media (max-width: 400px) {
    & > div {
      height: 200px !important;
    }
  }
`;

export const gallery__container_large = css`
  grid-template-columns: repeat(auto-fit, minmax(382px, 1fr));

  & > div {
    height: 400px !important;
    &:last-child,
    &:nth-last-child(2) {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(332px, 1fr));

    & > div {
      display: none;

      &:last-child,
      &:nth-last-child(2) {
        display: flex;
      }
    }
  }

  @media (max-width: 400px) {
    & > div {
      height: 360px !important;
    }
  }
`;

export const gallery = css`
  display: flex;
  flex-direction: column;
`;

export const gallery_paddings = css`
  padding-top: var(--space-1000);
  padding-bottom: var(--space-1000);

  @media (max-width: 390px) {
    padding-top: var(--space-500);
    padding-bottom: var(--space-500);
  }
`;

export const gallery__header = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  padding-bottom: var(--space-300);
`;
